import { Editor } from '@tldraw/tldraw'
import { useToggleRemoveBackground } from 'components/Design/utils/useToggleRemoveBackground'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { Image03 } from 'blaze-ui/icons/24'
import { Scissors4 } from 'blaze-ui/icons'
import { MobileButton } from 'components/MobileButton/MobileButton'

interface Props {
  editor: Editor
  selectedShape: ImageShape
}

export const MobileBackgroundButton = ({ editor, selectedShape }: Props) => {
  const { toggle, isDisabled } = useToggleRemoveBackground({ editor, shape: selectedShape })
  const backgroundRemoved = selectedShape.props.removeBackground
  const Icon = backgroundRemoved ? () => <Image03 size={16} /> : Scissors4

  if (isDisabled) {
    return null
  }

  return (
    <MobileButton variant="secondary" onPress={toggle} icon={Icon}>
      <div style={{ display: 'flex' }}>{backgroundRemoved ? 'Restore Background' : 'Remove Background'}</div>
    </MobileButton>
  )
}
